import hoistNonReactStatics from 'hoist-non-react-statics';
import useViewEvent from './useViewEvent';

export default function withViewEvent(WrappedComponent, eventName) {
  const Comp = props => {
    useViewEvent(eventName);
    return <WrappedComponent {...props} />;
  };
  return hoistNonReactStatics(Comp, WrappedComponent);
}
